export const getOverrideRemoteEntries = () => {
    let overrides = null;
    try {
        overrides = JSON.parse(localStorage.getItem('dev.override.remoteEntries') ?? 'null');
    }
    finally {
        // noop
    }
    return overrides;
};
